
import { Component, Vue } from "vue-property-decorator";

import TicketScanCamera from "@/components/TicketScanCamera.vue";
import TicketScanForm from "@/components/TicketScanForm.vue";
import { AuthModule } from "@/store/auth";

@Component({
  components: {
    TicketScanForm,
    TicketScanCamera,
  },
})
export default class Home extends Vue {
  public isShowingCamera = false;
  public isShowingForm = false;
  public qrContent: string | undefined;

  public successSound = new Audio(
    "https://firebasestorage.googleapis.com/v0/b/caca-ad5cd.appspot.com/o/success.mp3?alt=media&token=45b980be-3d01-4e87-80ea-1a13b4ec8785"
  );
  public errorSound = new Audio(
    "https://firebasestorage.googleapis.com/v0/b/caca-ad5cd.appspot.com/o/error.mp3?alt=media&token=867f0ae5-9b4e-4511-be44-1abff9c76dc4"
  );

  public created(): void {
    const currentToken = AuthModule.currentEventToken;

    if (currentToken === "") {
      this.$router.push({ path: "/Login" });
      this.$notify({
        group: "tickets",
        type: "error",
        title: "Ticket Form",
        text: `You must login to scan tickets`,
      });
    }
  }

  public openCamera(): void {
    this.isShowingCamera = !this.isShowingCamera;
  }

  public openForm(): void {
    console.log("called from child");
    this.isShowingCamera = !this.isShowingCamera;
  }

  public playError(): void {
    this.errorSound.play();
    this.errorSound.play();
  }

  public playSuccess(): void {
    this.successSound.play();
    this.errorSound.play();
  }
}
